import React, { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

// Lazy‑loaded page components
const HomePage = lazy(() => import('../pages/home/page'));
const NeedsPage = lazy(() => import('../pages/needs/page'));
const GuidePage = lazy(() => import('../pages/guide/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const HygieneNeedPage = lazy(() => import('../pages/needs/hygiene/page'));
const MobilityNeedPage = lazy(() => import('../pages/needs/mobility/page'));
const ComfortNeedPage = lazy(() => import('../pages/needs/comfort/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const HomeAdaptationPage = lazy(() => import('../pages/guide/home-adaptation/page'));
const SeniorAgePage = lazy(() => import('../pages/guide/senior-age/page'));
const AgingSignsPage = lazy(() => import('../pages/guide/aging-signs/page'));
const VetVisitPage = lazy(() => import('../pages/guide/vet-visit/page'));
const ArthritisPage = lazy(() => import('../pages/guide/arthritis/page'));
const SeniorNutritionPage = lazy(() => import('../pages/guide/senior-nutrition/page'));
import HomeAdaptationGuidePage from "../pages/guide/home-adaptation/page";
import IncontinenceGuidePage from "../pages/guide/incontinence/page";

/**
 * Helper that wraps a lazy component with <Suspense>.
 * This prevents the JSX‑parsing error in environments that do not
 * support JSX syntax directly (e.g., when the file is treated as plain
 * JavaScript). It also provides a fallback UI while the component is
 * loading, improving robustness.
 */
const withSuspense = (Component: React.LazyExoticComponent<React.ComponentType<any>>) => (
  <Suspense fallback={null}>
    <Component />
  </Suspense>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: withSuspense(HomePage),
  },
  {
    path: '/beduerfnisse',
    element: withSuspense(NeedsPage),
  },
  {
    path: '/beduerfnisse/hygiene-inkontinenz',
    element: withSuspense(HygieneNeedPage),
  },
  {
    path: '/beduerfnisse/mobilitaet-aufstehen',
    element: withSuspense(MobilityNeedPage),
  },
  {
    path: '/beduerfnisse/komfort-liegen',
    element: withSuspense(ComfortNeedPage),
  },
  {
    path: '/ratgeber',
    element: withSuspense(GuidePage),
  },
  {
    path: '/ratgeber/zuhause-seniorengerecht',
    element: <HomeAdaptationGuidePage />,
  },
  {
    path: '/ratgeber/inkontinenz',
    element: <IncontinenceGuidePage />,
  },
  {
    path: '/ratgeber/ab-wann-senior',
    element: withSuspense(SeniorAgePage),
  },
  {
    path: '/ratgeber/altersanzeichen',
    element: withSuspense(AgingSignsPage),
  },
  {
    path: '/ratgeber/wann-zum-tierarzt',
    element: withSuspense(VetVisitPage),
  },
  {
    path: '/ratgeber/arthrose',
    element: withSuspense(ArthritisPage),
  },
  {
    path: '/ratgeber/ernaehrung-im-alter',
    element: withSuspense(SeniorNutritionPage),
  },
  {
    path: '/ueber-hund-im-alter',
    element: withSuspense(AboutPage),
  },
  {
    path: '/impressum',
    element: withSuspense(ImpressumPage),
  },
  {
    path: '/datenschutz',
    element: withSuspense(DatenschutzPage),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
